import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchAdminPolls = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/polls/admin`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const createAdminPoll = async ({ network_id, question, expires_at }) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/polls/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ network_id, question, expires_at }),
    });
    if (!response.ok) throw new Error("Не вдалося створити опитування");
    return await response.json();
};

export const fetchUnreadAdminPolls = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/polls/admin/unread`);
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};

export const markAdminPollsViewed = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/polls/admin/mark-viewed/polls`, {
        method: "PUT",
    });
    if (!response.ok) throw new Error("Сесія закінчилася. Увійдіть знову.");
    return await response.json();
};
